import React, { useEffect, useState, FC } from "react";
import { Modal, ModalBody, Alert } from "reactstrap";
import { Icon, Button } from "../../../components/Component";
import { Row, Col } from "reactstrap";
import { FormProvider, useForm } from "react-hook-form";
import FormInput from "../../form-components/InputComponent";
import FormTextArea from "../../form-components/TextAreaComponent";
import sequenceApis from "../../../api/master/sequence";

const AddModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  alertInfo,
  isSequenceSet = false,
}) => {
  const [localIsSequenceSet, setLocalIsSequenceSet] = useState(false);
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = methods;

  const fetchSequenceStatus = async () => {
    try {
      const response = await sequenceApis.fetchSequenceByModuleId(178);
      const { data } = response;
      const today = new Date();
      // Check if sequence exists with:
      // 1. moduleId === 178 (Work Uom)
      // 2. status === "Active" (if "Active", hide Work UOM Sequence ID field)
      // 3. endDate is in the future
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleId === 178 &&
          item.status === "Active" &&
          new Date(item.endDate) > today
      );
      setLocalIsSequenceSet(_sequenceAccess && _sequenceAccess.length > 0);
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setLocalIsSequenceSet(false);
    }
  };

  // Fetch sequence status when modal opens
  useEffect(() => {
    if (modal) {
      fetchSequenceStatus();
      reset({
        workUomSequenceId: "",
        uomName: "",
        uomShortCode: "",
        uomDescription: "",
        uomType: "",
      });
    }
  }, [modal, reset]);

  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="xl"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Add Work UOM</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="gy-2">
                  {!localIsSequenceSet && (
                    <Col md="4" className="mb-2">
                      <FormInput
                        name="workUomSequenceId"
                        label="Work UOM Sequence ID"
                        required={true}
                        type="text"
                        placeholder="Enter Work UOM Sequence ID"
                      />
                    </Col>
                  )}
                  <Col md="4" className="mb-2">
                    <FormInput
                      name="uomType"
                      label="UOM Type"
                      required={true}
                      type="text"
                      placeholder="Enter UOM Type (e.g., Volume)"
                    />
                  </Col>
                  <Col md="4" className="mb-2">
                    <FormInput
                      name="uomName"
                      label="UOM Name"
                      required={true}
                      type="text"
                      placeholder="Enter UOM Name"
                    />
                  </Col>
                  <Col md="4" className="mb-2">
                    <FormInput
                      name="uomShortCode"
                      label="UOM Short Code"
                      required={true}
                      type="text"
                      placeholder="Enter UOM Short Code"
                    />
                  </Col>
                  <Col md="12" className="mb-2"> 
                    <FormTextArea
                      name="uomDescription"
                      label="UOM Description"
                      required={true}
                      placeholder="Write your description"
                    />
                  </Col>
                  <Row className="mt-2"> 
                    <Col>
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button color="primary" size="md" type="submit">
                            Add
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              closeModal();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Row>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddModal;

